import './cities-selection.scss';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { colors } from '@/Themes/Colors';
import { useAppDispatch } from '@/_store/hooks';
import { useCities } from '@/_hooks/use-cities';
import { setFilterCityOnDashboard } from '@/_store/modules/filters/slice';
import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';

function CitiesSelection() {
  const dispatch = useAppDispatch();

  const { CITIES_OPTIONS, loadingCities, selectedCity } = useCities();

  return (
    <div className="cities-selection-container">
      <div className="icon-city-container">
        <div className="icon-city">
          <FontAwesomeIcon icon={faMapMarkerAlt} color={colors.brand10} />
        </div>
        <span className="subtitle1">Município</span>
      </div>
      <div>
        <DropdownInput
          search
          options={CITIES_OPTIONS}
          loading={loadingCities}
          value={selectedCity}
          className="cities"
          onChange={data => {
            dispatch(setFilterCityOnDashboard(data as string));
          }}
          containerClassName="cities-selection"
        />
      </div>
    </div>
  );
}

export default CitiesSelection;
